import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';

interface NewCaptureCardProps {
  onCreateNew: () => void;
  type: 'email' | 'password';
}

export function NewCaptureCard({ onCreateNew, type }: NewCaptureCardProps) {
  useLanguage();
  const title = type === 'email' ? translateInterfaceText("Captura com E-mail") : translateInterfaceText("Captura com Senha");

  return (
    <Card
      className={cn(
        'relative overflow-hidden transition-all duration-200 cursor-pointer',
        'border-2 border-dashed border-primary/30 bg-card hover:border-primary/50',
        'rounded-2xl',
        'shadow-sm hover:shadow-md'
      )}
      onClick={onCreateNew}
    >
      {/* Área do thumbnail - 16:9 aspect ratio (IGUAL aos cards de vídeo) */}
      <div className="relative aspect-video overflow-hidden bg-gradient-to-br from-primary/5 via-primary/10 to-primary/5 flex items-center justify-center">
        <div className="flex flex-col items-center justify-center gap-3">
          <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center">
            <Plus className="w-8 h-8 text-primary" />
          </div>
          <p className="text-sm font-medium text-primary">{translateInterfaceText("Nova Captura")}</p>
        </div>
      </div>

      {/* Card Footer - Botão centralizado */}
      <CardContent className="p-3 flex items-center justify-center">
        <Button 
          onClick={(e) => {
            e.stopPropagation();
            onCreateNew();
          }}
          className="w-full h-9"
          size="default"
        >
          <Plus className="w-4 h-4 mr-2" />
          {translateInterfaceText("Criar")}{" "}{title}
        </Button>
      </CardContent>
    </Card>
  );
}
